import * as React from 'react';

import { IconPropsType } from 'designSystem/types/icons';

interface IRefreshIconProps extends IconPropsType {}

const RefreshIcon = ({
  size = 20,
  fill = '#5D5F66',
  fillOpacity = '0.8',
  ...props
}: IRefreshIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 3.14286C9.09857 3.14061 8.20564 3.31717 7.3729 3.66231C6.54015 4.00744 5.78413 4.51431 5.14857 5.15357C4.62929 5.67929 4.16786 6.185 3.71429 6.71429V5.42857C3.71429 5.27702 3.65408 5.13168 3.54692 5.02451C3.43976 4.91735 3.29441 4.85714 3.14286 4.85714C2.99131 4.85714 2.84596 4.91735 2.7388 5.02451C2.63163 5.13168 2.57143 5.27702 2.57143 5.42857V8.28572C2.57143 8.43727 2.63163 8.58261 2.7388 8.68978C2.84596 8.79694 2.99131 8.85714 3.14286 8.85714H6C6.15155 8.85714 6.2969 8.79694 6.40406 8.68978C6.51123 8.58261 6.57143 8.43727 6.57143 8.28572C6.57143 8.13416 6.51123 7.98882 6.40406 7.88166C6.2969 7.77449 6.15155 7.71429 6 7.71429H4.35714C4.86786 7.11286 5.37643 6.54643 5.95643 5.95929C6.75061 5.16511 7.76122 4.62258 8.86198 4.39949C9.96274 4.17639 11.1048 4.28263 12.1456 4.70492C13.1863 5.12721 14.0795 5.84683 14.7136 6.77386C15.3476 7.7009 15.6945 8.79423 15.7107 9.91725C15.727 11.0403 15.4119 12.1432 14.8049 13.0882C14.1979 14.0332 13.3259 14.7783 12.2978 15.2305C11.2697 15.6827 10.1312 15.822 9.02445 15.6308C7.9177 15.4397 6.89182 14.9266 6.075 14.1557C6.02041 14.1041 5.95619 14.0638 5.88601 14.037C5.81583 14.0102 5.74106 13.9976 5.66598 13.9997C5.5909 14.0018 5.51697 14.0187 5.44841 14.0494C5.37986 14.0801 5.31802 14.124 5.26643 14.1786C5.21484 14.2332 5.17451 14.2974 5.14773 14.3676C5.12096 14.4377 5.10827 14.5125 5.1104 14.5876C5.11252 14.6627 5.12941 14.7366 5.1601 14.8052C5.1908 14.8737 5.23469 14.9356 5.28929 14.9871C6.10318 15.7552 7.09268 16.3124 8.17143 16.6101C9.25018 16.9078 10.3854 16.9369 11.478 16.695C12.5706 16.453 13.5874 15.9474 14.4396 15.2221C15.2919 14.4968 15.9537 13.574 16.3672 12.5342C16.7808 11.4943 16.9336 10.369 16.8123 9.25656C16.6909 8.14409 16.2992 7.07821 15.6712 6.15195C15.0432 5.2257 14.198 4.46722 13.2095 3.9427C12.221 3.41819 11.1191 3.14359 10 3.14286Z"
      fill={fill}
    />
  </svg>
);

export default RefreshIcon;
